/**
 * Shift Notes Form JavaScript
 * Handles password protection, dynamic sections, and form submission
 */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    password: 'MGH',
    web3formsEndpoint: 'https://api.web3forms.com/submit',
    googleSheetsEndpoint: 'https://script.google.com/macros/s/AKfycbzeTP24bmHbu6prWcAo6RYi08DDwzs8Q-Rq6R6tUxqKe_n4FCqR-iY7A-TXwsaF0LJMAQ/exec',
    googleSheetsViewUrl: 'https://drive.google.com/drive/folders/1hF5UYkp2BiksJPtwp95mQBk7uh1BbOWD?usp=drive_link',
    maxDynamicItems: 10
  };

  // Dynamic section templates
  const SECTION_TEMPLATES = {
    'service-dropoffs': (index) => `
      <div class="dynamic-item" data-index="${index}">
        <button type="button" class="remove-btn" aria-label="Remove">&times;</button>
        <div class="form-group">
          <label>Machine Name & Model</label>
          <input type="text" name="Service Dropoff ${index} - Machine" placeholder="e.g. Dyson V15">
        </div>
        <div class="form-group">
          <label>Issue Description</label>
          <textarea name="Service Dropoff ${index} - Issue" rows="2" placeholder="Describe the issue"></textarea>
        </div>
        <div class="form-group">
          <label>Location in Store</label>
          <input type="text" name="Service Dropoff ${index} - Location" placeholder="Where is it stored?">
        </div>
      </div>
    `,
    'services-completed': (index) => `
      <div class="dynamic-item" data-index="${index}">
        <button type="button" class="remove-btn" aria-label="Remove">&times;</button>
        <div class="form-group">
          <label>Machine Name & Model</label>
          <input type="text" name="Service Completed ${index} - Machine" placeholder="e.g. Miele C3">
        </div>
        <div class="form-group">
          <label>Service Description</label>
          <textarea name="Service Completed ${index} - Description" rows="2" placeholder="Describe the service completed"></textarea>
        </div>
      </div>
    `,
    'customer-inquiries': (index) => `
      <div class="dynamic-item" data-index="${index}">
        <button type="button" class="remove-btn" aria-label="Remove">&times;</button>
        <div class="form-group">
          <label>Customer Name</label>
          <input type="text" name="Customer Inquiry ${index} - Name" placeholder="Customer name">
        </div>
        <div class="form-group">
          <label>Phone Number</label>
          <input type="tel" name="Customer Inquiry ${index} - Phone" placeholder="Phone number">
        </div>
        <div class="form-group">
          <label>What They Need</label>
          <textarea name="Customer Inquiry ${index} - Need" rows="2" placeholder="What are they looking for?"></textarea>
        </div>
      </div>
    `,
    'orders-received': (index) => `
      <div class="dynamic-item" data-index="${index}">
        <button type="button" class="remove-btn" aria-label="Remove">&times;</button>
        <div class="form-group">
          <label>What Came In</label>
          <textarea name="Order Received ${index} - Items" rows="2" placeholder="Describe what was received"></textarea>
        </div>
        <div class="form-group">
          <label>Where Stored</label>
          <input type="text" name="Order Received ${index} - Location" placeholder="Where is it stored?">
        </div>
      </div>
    `,
    'diagnostics-completed': (index) => `
      <div class="dynamic-item" data-index="${index}">
        <button type="button" class="remove-btn" aria-label="Remove">&times;</button>
        <div class="form-group">
          <label>Machine Name & Model</label>
          <input type="text" name="Diagnostic Completed ${index} - Machine" placeholder="e.g. Dyson V15">
        </div>
        <div class="form-group">
          <label>Diagnosis/Findings</label>
          <textarea name="Diagnostic Completed ${index} - Diagnosis" rows="2" placeholder="Describe the diagnosis findings"></textarea>
        </div>
      </div>
    `
  };

  // DOM Ready
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    setupPasswordGate();
    setupDateField();
    setupDrawerToggle();
    setupDiagnosticsToggle();
    setupDynamicSections();
    setupFormSubmission();
    setupHistoryLink();
  }

  /**
   * Drawer at $200 - Show/hide amount and explain fields
   */
  function setupDrawerToggle() {
    const drawerRadios = document.querySelectorAll('input[name="Drawer At 200"]');
    const amountGroup = document.getElementById('drawer-amount-group');
    const amountField = document.getElementById('drawer-amount');
    const explainGroup = document.getElementById('drawer-explain-group');
    const explainField = document.getElementById('drawer-explain');

    if (!drawerRadios.length || !amountGroup || !explainGroup) return;

    drawerRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        if (this.value === 'No') {
          amountGroup.style.display = 'block';
          explainGroup.style.display = 'block';
          amountField.focus();
        } else {
          amountGroup.style.display = 'none';
          explainGroup.style.display = 'none';
          amountField.value = '';
          explainField.value = '';
        }
      });
    });
  }

  /**
   * Diagnostics Over 24 Hours - Show/hide explain field
   */
  function setupDiagnosticsToggle() {
    const diagRadios = document.querySelectorAll('input[name="Diagnostics Over 24 Hours"]');
    const explainGroup = document.getElementById('diagnostics-explain-group');
    const explainField = document.getElementById('diagnostics-explain');

    if (!diagRadios.length || !explainGroup) return;

    diagRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        if (this.value === 'Yes') {
          explainGroup.style.display = 'block';
          explainField.focus();
        } else {
          explainGroup.style.display = 'none';
          explainField.value = '';
        }
      });
    });
  }

  /**
   * Setup History Link
   */
  function setupHistoryLink() {
    const historyLink = document.getElementById('view-history-link');
    if (historyLink && CONFIG.googleSheetsViewUrl !== 'YOUR_GOOGLE_SHEETS_VIEW_URL') {
      historyLink.href = CONFIG.googleSheetsViewUrl;
    }
  }

  /**
   * Password Gate
   */
  function setupPasswordGate() {
    const passwordGate = document.getElementById('password-gate');
    const formContainer = document.getElementById('shift-form-container');
    const passwordInput = document.getElementById('password-input');
    const passwordSubmit = document.getElementById('password-submit');
    const passwordError = document.getElementById('password-error');

    // Check if already authenticated in this session
    if (sessionStorage.getItem('shift-notes-auth') === 'true') {
      passwordGate.style.display = 'none';
      formContainer.style.display = 'block';
      return;
    }

    function checkPassword() {
      const entered = passwordInput.value;
      if (entered === CONFIG.password) {
        sessionStorage.setItem('shift-notes-auth', 'true');
        passwordGate.style.display = 'none';
        formContainer.style.display = 'block';
      } else {
        passwordError.style.display = 'block';
        passwordInput.value = '';
        passwordInput.focus();
      }
    }

    passwordSubmit.addEventListener('click', checkPassword);
    passwordInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        checkPassword();
      }
    });

    // Focus password input
    passwordInput.focus();
  }

  /**
   * Auto-fill today's date
   */
  function setupDateField() {
    const dateField = document.getElementById('shift-date');
    if (dateField) {
      const today = new Date().toISOString().split('T')[0];
      dateField.value = today;
    }
  }

  /**
   * Dynamic Add/Remove Sections
   */
  function setupDynamicSections() {
    // Add buttons
    document.querySelectorAll('.add-btn').forEach(button => {
      button.addEventListener('click', function() {
        const sectionName = this.dataset.section;
        addDynamicItem(sectionName);
      });
    });

    // Remove buttons (using event delegation)
    document.addEventListener('click', function(e) {
      if (e.target.classList.contains('remove-btn')) {
        removeDynamicItem(e.target);
      }
    });
  }

  function addDynamicItem(sectionName) {
    const container = document.getElementById(sectionName + '-container');
    if (!container) return;

    const items = container.querySelectorAll('.dynamic-item');
    if (items.length >= CONFIG.maxDynamicItems) {
      alert('Maximum ' + CONFIG.maxDynamicItems + ' items allowed per section.');
      return;
    }

    const newIndex = items.length + 1;
    const template = SECTION_TEMPLATES[sectionName];
    if (!template) return;

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = template(newIndex).trim();
    const newItem = tempDiv.firstChild;

    container.appendChild(newItem);

    // Focus first input in new item
    const firstInput = newItem.querySelector('input, textarea');
    if (firstInput) {
      firstInput.focus();
    }

    // Add remove button to first item if there's now more than one
    if (items.length === 1 && !items[0].querySelector('.remove-btn')) {
      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'remove-btn';
      removeBtn.setAttribute('aria-label', 'Remove');
      removeBtn.innerHTML = '&times;';
      items[0].insertBefore(removeBtn, items[0].firstChild);
    }
  }

  function removeDynamicItem(removeBtn) {
    const item = removeBtn.closest('.dynamic-item');
    const container = item.parentElement;
    const items = container.querySelectorAll('.dynamic-item');

    // Don't remove if it's the only item
    if (items.length === 1) {
      // Clear the fields instead
      item.querySelectorAll('input, textarea').forEach(field => {
        field.value = '';
      });
      return;
    }

    item.remove();

    // Remove the remove button from the last remaining item if only one left
    const remainingItems = container.querySelectorAll('.dynamic-item');
    if (remainingItems.length === 1) {
      const lastRemoveBtn = remainingItems[0].querySelector('.remove-btn');
      if (lastRemoveBtn) {
        lastRemoveBtn.remove();
      }
    }

    // Renumber remaining items
    renumberItems(container);
  }

  function renumberItems(container) {
    const items = container.querySelectorAll('.dynamic-item');
    items.forEach((item, idx) => {
      const index = idx + 1;
      item.dataset.index = index;

      // Update field names
      item.querySelectorAll('input, textarea').forEach(field => {
        const name = field.name;
        if (name) {
          // Replace the number in the name
          field.name = name.replace(/\d+/, index);
        }
      });
    });
  }

  /**
   * Form Submission
   */
  function setupFormSubmission() {
    const form = document.getElementById('shift-notes-form');
    const submitBtn = document.getElementById('submit-btn');
    const statusDiv = document.getElementById('form-status');

    form.addEventListener('submit', async function(e) {
      e.preventDefault();

      // Validate required fields
      if (!validateForm(form)) {
        return;
      }

      // Show loading state
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span class="spinner"></span>Submitting...';
      statusDiv.style.display = 'block';
      statusDiv.className = 'form-status loading';
      statusDiv.textContent = 'Sending shift notes...';

      try {
        // Collect form data
        const formData = new FormData(form);

        // Clean up empty dynamic fields
        const cleanedData = new FormData();
        for (const [key, value] of formData.entries()) {
          if (value.toString().trim() !== '' || key === 'access_key' || key === 'subject' || key === 'from_name') {
            cleanedData.append(key, value);
          }
        }

        // Submit to Web3Forms
        const response = await fetch(CONFIG.web3formsEndpoint, {
          method: 'POST',
          body: cleanedData
        });

        const result = await response.json();

        if (result.success) {
          // Also submit to Google Sheets for historical storage
          if (CONFIG.googleSheetsEndpoint !== 'YOUR_GOOGLE_APPS_SCRIPT_URL') {
            try {
              await submitToGoogleSheets(cleanedData);
            } catch (sheetsError) {
              console.warn('Google Sheets submission failed:', sheetsError);
              // Don't fail the whole submission if Sheets fails
            }
          }

          statusDiv.className = 'form-status success';
          statusDiv.textContent = 'Shift notes submitted successfully! The team has been notified.';
          form.reset();
          setupDateField(); // Re-fill today's date

          // Scroll to status message
          statusDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          throw new Error(result.message || 'Submission failed');
        }
      } catch (error) {
        console.error('Form submission error:', error);
        statusDiv.className = 'form-status error';
        statusDiv.textContent = 'Error submitting form. Please try again or contact support.';
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit Shift Notes';
      }
    });
  }

  function validateForm(form) {
    const requiredFields = form.querySelectorAll('[required]');
    let isValid = true;

    requiredFields.forEach(field => {
      if (!field.value.trim()) {
        field.style.borderColor = '#dc2626';
        isValid = false;

        // Remove red border on input
        field.addEventListener('input', function() {
          this.style.borderColor = '';
        }, { once: true });
      }
    });

    if (!isValid) {
      // Focus first invalid field
      const firstInvalid = form.querySelector('[required]:invalid, [required][style*="border-color: rgb(220, 38, 38)"]');
      if (firstInvalid) {
        firstInvalid.focus();
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    return isValid;
  }

  /**
   * Submit form data to Google Sheets via Apps Script
   */
  async function submitToGoogleSheets(formData) {
    // Convert FormData to a plain object for Google Sheets
    const data = {};
    for (const [key, value] of formData.entries()) {
      // Skip Web3Forms-specific fields
      if (key === 'access_key' || key === 'subject' || key === 'from_name') {
        continue;
      }
      data[key] = value;
    }

    // Add timestamp
    data['Submitted At'] = new Date().toISOString();

    const response = await fetch(CONFIG.googleSheetsEndpoint, {
      method: 'POST',
      mode: 'no-cors', // Google Apps Script doesn't support CORS properly
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    });

    return response;
  }

})();
